import { useMutation, useQueryClient } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { ScribeSession, UpdateSessionDto } from '@/types';

export const useSessionUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: {
      id: string;
      data: UpdateSessionDto;
    }): Promise<ScribeSession> => {
      const response = await httpClient.patch<ScribeSession>(
        `/v1/sessions/${params.id}`,
        params.data,
      );
      return response.data;
    },
    onSuccess: (session) => {
      void queryClient.invalidateQueries({
        queryKey: ['scribeSession', session.id],
      });
      void queryClient.invalidateQueries({ queryKey: ['scribeSessions'] });
    },
  });
};
